import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';

const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_FIREBASE_APP_ID,
	measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

// eslint-disable import/prefer-default-export

export const generateToken = async () => {
	try {
		const permission = await Notification.requestPermission();
		if (permission === 'granted') {
			return await getToken(messaging, {
				vapidKey:
					'BNqKCL5xH5hhen_5gB5PwvwbtIuad6CjQQpeh6KokSfa7FdGvTlCb0bGmwr61M5d-61iihpf9IzBIgibi0wzr0E',
			});
		}
		return null;
	} catch (e) {
		return e;
	}
};
